import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { IModificationSlice, IPersonalDetailsPayload } from "./types"

const initialState: IModificationSlice = {
  uploadDocument: {
    loading: false,
    isError: false,
    errMessage: "",
    data: {},
    status: null,
  },
  uploadPersonalDetails: {
    loading: false,
    isError: false,
    errMessage: "",
    data: {},
    status: null,
  },

}

export const modificationSlice = createSlice({
  name: "modification",
  initialState,
  reducers: {
    uploadDocument: (state, action:PayloadAction<any>) => {
      state.uploadDocument.loading = true
      state.uploadDocument.status = null
      state.uploadDocument.isError = false
    },
    uploadDocumentSuccess: (state, action) => {
      state.uploadDocument.loading = false
      state.uploadDocument.data = action.payload.data
      state.uploadDocument.status = action.payload.status
    },
    uploadDocumentFailure: (state, action) => {
      state.uploadDocument.loading = false
      state.uploadDocument.isError = true
      state.uploadDocument.status = action.payload.status
      state.uploadDocument.errMessage = action.payload.error
      state.uploadDocument.data = action.payload.data
    },
    uploadPersonalDetails: (state, action:PayloadAction<IPersonalDetailsPayload>) => {
      state.uploadPersonalDetails.loading = true
      state.uploadPersonalDetails.status = null
      state.uploadPersonalDetails.isError = false
    },
    uploadPersonalDetailsSuccess: (state, action) => {
      state.uploadPersonalDetails.loading = false
      state.uploadPersonalDetails.data = action.payload.data
      state.uploadPersonalDetails.status = action.payload.status
    },
    uploadPersonalDetailsFailure: (state, action) => {
      state.uploadPersonalDetails.loading = false
      state.uploadPersonalDetails.isError = true
      state.uploadPersonalDetails.data = action.payload.data
      state.uploadPersonalDetails.status = action.payload.status
      state.uploadPersonalDetails.errMessage = action.payload.error
    },
    // resetTradesSlice: () => initialState,
  },
})

export const {
  uploadDocument,
  uploadDocumentSuccess,
  uploadDocumentFailure,
  uploadPersonalDetails,
  uploadPersonalDetailsSuccess,
  uploadPersonalDetailsFailure,
} = modificationSlice.actions

export default modificationSlice.reducer
